import { Operation as FastOpertaion } from "fast-json-patch";

export class Operation {
    public operation: FastOpertaion;
    constructor(op: FastOpertaion) {
        this.operation = op;
    }

    public toJSON = () => this.operation;
    public static fromJS = (item: string) => new Operation(JSON.parse(item));
}